import { render, staticRenderFns } from "./notification-ActivityCommentMention.vue?vue&type=template&id=13ce8ea3&scoped=true"
import script from "./notification-ActivityCommentMention.vue?vue&type=script&lang=js"
export * from "./notification-ActivityCommentMention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce8ea3",
  null
  
)

export default component.exports